import { render } from "./ViewerForm.vue?vue&type=template&id=2bf9225a"
import script from "./ViewerForm.vue?vue&type=script&lang=js"
export * from "./ViewerForm.vue?vue&type=script&lang=js"
script.render = render

export default script